import { useState } from "react";

export type RiskIdentificationsManager = {
    showWorkAtHeightChecklistModal: boolean;
    showScaffoldingChecklistModal: boolean;
    showScaffoldingConstructionChecklistModal: boolean;
    showScaffoldingWorkChecklistModal: boolean;
    showClosedSpaceChecklistModal: boolean;
    showAsbestosChecklistModal: boolean;
    showHydrogenSulphideChecklistModal: boolean;
    showBeefGasChecklistModal: boolean;
    showHeavyLiftingChecklistModal: boolean;
    showExcavationAndPolingChecklistModal: boolean;
    showRaftChecklistModal: boolean;
    showDivingChecklistModal: boolean;
    setShowWorkAtHeightChecklistModal: (show: boolean) => void;
    setShowScaffoldingChecklistModal: (show: boolean) => void;
    setShowScaffoldingConstructionChecklistModal: (show: boolean) => void;
    setShowScaffoldingWorkChecklistModal: (show: boolean) => void;
    setShowClosedSpaceChecklistModal: (show: boolean) => void;
    setShowAsbestosChecklistModal: (show: boolean) => void;
    setShowHydrogenSulphideChecklistModal: (show: boolean) => void;
    setShowBeefGasChecklistModal: (show: boolean) => void;
    setShowHeavyLiftingChecklistModal: (show: boolean) => void;
    setShowExcavationAndPolingChecklistModal: (show: boolean) => void;
    setShowRaftChecklistModal: (show: boolean) => void;
    setShowDivingChecklistModal: (show: boolean) => void;
}

export default function useRiskIdentifications(): RiskIdentificationsManager {
    const [showWorkAtHeightChecklistModal, setShowWorkAtHeightChecklistModal] = useState(false);
    const [showScaffoldingChecklistModal, setShowScaffoldingChecklistModal] = useState(false);
    const [showScaffoldingConstructionChecklistModal, setShowScaffoldingConstructionChecklistModal] = useState(false);
    const [showScaffoldingWorkChecklistModal, setShowScaffoldingWorkChecklistModal] = useState(false);
    const [showClosedSpaceChecklistModal, setShowClosedSpaceChecklistModal] = useState(false);
    const [showAsbestosChecklistModal, setShowAsbestosChecklistModal] = useState(false);
    const [showHydrogenSulphideChecklistModal, setShowHydrogenSulphideChecklistModal] = useState(false);
    const [showBeefGasChecklistModal, setShowBeefGasChecklistModal] = useState(false);
    const [showHeavyLiftingChecklistModal, setShowHeavyLiftingChecklistModal] = useState(false);
    const [showExcavationAndPolingChecklistModal, setShowExcavationAndPolingChecklistModal] = useState(false);
    const [showRaftChecklistModal, setShowRaftChecklistModal] = useState(false);
    const [showDivingChecklistModal, setShowDivingChecklistModal] = useState(false);

    return {
        showWorkAtHeightChecklistModal,
        showScaffoldingChecklistModal,
        showScaffoldingConstructionChecklistModal,
        showScaffoldingWorkChecklistModal,
        showClosedSpaceChecklistModal,
        showAsbestosChecklistModal,
        showHydrogenSulphideChecklistModal,
        showBeefGasChecklistModal,
        showHeavyLiftingChecklistModal,
        showExcavationAndPolingChecklistModal,
        showRaftChecklistModal,
        showDivingChecklistModal,
        setShowWorkAtHeightChecklistModal,
        setShowScaffoldingChecklistModal,
        setShowScaffoldingConstructionChecklistModal,
        setShowScaffoldingWorkChecklistModal,
        setShowClosedSpaceChecklistModal,
        setShowAsbestosChecklistModal,
        setShowHydrogenSulphideChecklistModal,
        setShowBeefGasChecklistModal,
        setShowHeavyLiftingChecklistModal,
        setShowExcavationAndPolingChecklistModal,
        setShowRaftChecklistModal,
        setShowDivingChecklistModal
    }
}
